var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React from 'react';
import { Grid } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { KEYS } from '../../../i18n';
import { toast } from 'react-toastify';
import { TextOverflow } from '../../TextOverflow';
import FormGroup from '@material-ui/core/FormGroup/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel/FormControlLabel';
import Switch from '@material-ui/core/Switch/Switch';
import { BasicDialog } from '../../Dialog';
import { ResendNotifications } from '../../../graphql/order/resend.notifications';
import OrderRouteMenuItem from './OrderRoutesMenuItem';
import AddAlertIcon from '@material-ui/icons/AddAlert';
import BaseTooltip from '../../BaseTooltip';
import BaseIconButton from '../../BaseIconButton';
export default (function (_a) {
    var config = _a.config, order = _a.order, label = _a.label;
    var langForm = useTranslation(KEYS.FORM);
    var langToast = useTranslation(KEYS.TOAST);
    var langAPP = useTranslation(KEYS.APP);
    var _b = __read(React.useState(false), 2), sendSms = _b[0], setSendSms = _b[1];
    var _c = __read(React.useState(false), 2), loading = _c[0], setLoading = _c[1];
    var handleChange = function () { return setSendSms(!sendSms); };
    var onOk = function () { return __awaiter(void 0, void 0, void 0, function () {
        var e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, 3, 4]);
                    setLoading(true);
                    return [4 /*yield*/, config.client.mutate({
                            mutation: ResendNotifications,
                            variables: { input: { _id: order._id, sendSms: sendSms } },
                        })];
                case 1:
                    _a.sent();
                    toast.success(langToast.t('toast_items_sent').replace(/_X_/, langAPP.t('main_notification')));
                    return [3 /*break*/, 4];
                case 2:
                    e_1 = _a.sent();
                    toast.error(e_1.message || e_1);
                    return [3 /*break*/, 4];
                case 3:
                    setLoading(false);
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var dialogBody = (React.createElement(Grid, { container: true, direction: 'column', justify: 'center' },
        React.createElement(Grid, { container: true, justify: 'center' },
            React.createElement(FormGroup, { onClick: handleChange },
                React.createElement(FormControlLabel, { control: React.createElement(Switch, { color: 'primary', checked: sendSms, name: 'sendSms' }), label: React.createElement(Grid, { container: true, alignItems: 'center' },
                        React.createElement(TextOverflow, { variant: 'subtitle1' }, langForm.t('form_invoice_create_send_with_sms'))) })))));
    var icon = (React.createElement(BaseTooltip, { title: langForm.t('form_btn_send_notification') },
        React.createElement(BaseIconButton, { color: 'primary', disabled: loading, id: 'btn-notify-published' },
            React.createElement(AddAlertIcon, { style: { width: 22 } }))));
    return (React.createElement(BasicDialog, { withoutWrapper: true, body: dialogBody, title: langForm.t('form_btn_send_notification'), onOk: onOk, dialogProps: { fullWidth: true, maxWidth: 'sm' }, actionInit: function (handleClickOpen) {
            return label ? (React.createElement(OrderRouteMenuItem, __assign({}, { icon: icon, label: langForm.t('form_btn_send_notification'), handleClickOpen: handleClickOpen }))) : (React.createElement("span", { id: 'btn-send-notification', onClick: handleClickOpen }, icon));
        } }));
});
